import React from 'react';

import bg403 from '@assets/images/bg-403.png';
import { ReactComponent as Error403Icon } from '@assets/svg/ic-error-403-icon.svg';

import Button from '@components/uikit/Button/Button';

import useTranslation from '@hooks/useTranslation';

import style from './style.module.scss';

const Error403 = () => {
  const { t } = useTranslation();

  const logout = () => window.location.replace(APP_SSO_URL + 'logout-simple/2');

  return (
    <div className={style.errorPage}>
      <img src={bg403} alt="bg-403" className={style.errorPageBgImage} />
      <div className={style.errorPageBody}>
        <Error403Icon className={style.errorPageIcon} />
        <div className={style.errorPageInfo}>
          <h1 className={style.errorPageTitle}>
            {t("Oops! It seems you've stumbled upon a 403 — Access Denied  / Forbidden")}
          </h1>
          <p className={style.errorPageText}>
            <span>{t('Access to this resource on the server is denied.')}</span>
            <span
              dangerouslySetInnerHTML={{
                __html: t('If you believe this is an error, please contact support at {supportLink}.', {
                  supportLink: `<a href="mailto:support@waites.net">support@waites.net</a>`,
                }),
              }}
            />
          </p>
        </div>
        <div className={style.errorPageButtons}>
          <Button onClick={logout} type="outline" text={t('Logout')} variant="small" />
          <Button
            onClick={() => (window.location.href = window.location.origin)}
            type="primary"
            text={t('Home Page')}
            variant="small"
          />
        </div>
      </div>
    </div>
  );
};

export default Error403;
